import { Suspense } from 'react';
import loadable from '@loadable/component';

const EmptyLoader = () => <div />;

const lazyLoadSVG = (factory: any) => {
	const SVG = loadable(factory);

	const LazySVG = (props: { [key: string]: any }) => (
		<Suspense fallback={<EmptyLoader />}>
			<SVG {...props} />
		</Suspense>
	);

	return LazySVG;
};

export default lazyLoadSVG;
